import {
  getLocalStorage,
  removeLocalStorage,
  setBoolLocalStorage,
  setLocalStorage,
} from "./set-get-local-storage";

export const setAuthToken = (value) =>
  setLocalStorage(process.env.REACT_APP_TOKEN_NAME || `sATPC`, value, 24);
export const getAuthToken = () =>
  getLocalStorage(process.env.REACT_APP_TOKEN_NAME || `sATPC`) || undefined;
export const removeAuthToken = () =>
  removeLocalStorage(process.env.REACT_APP_TOKEN_NAME || `sATPC`);

export const setAuthTokenType = (value) =>
  setLocalStorage(
    process.env.REACT_APP_TOKEN_TYPE_NAME || `sATTPC`,
    value,
    24
  );
export const getAuthTokenType = () =>
  getLocalStorage(process.env.REACT_APP_TOKEN_TYPE_NAME || `sATTPC`) ||
  undefined;
export const removeAuthTokenType = () =>
  removeLocalStorage(
    process.env.REACT_APP_TOKEN_TYPE_NAME || `sATTPC`,
    "",
    24
  );

export const setUserDetails = (value) =>
  setLocalStorage(process.env.REACT_APP_USER_DETAILS || `sUDPC`, value, 24);
export const getUserDetails = () =>
  getLocalStorage(process.env.REACT_APP_USER_DETAILS || `sUDPC`) || undefined;
export const removeUserDetails = () =>
  removeLocalStorage(process.env.REACT_APP_USER_DETAILS || `sUDPC`);

export const setCurrentDeviceDetails = (value) =>
  setLocalStorage(
    process.env.REACT_APP_CURRENT_DEVICE_DETAILS || `sCDPC`,
    value,
    24
  );
export const getCurrentDeviceDetails = () =>
  getLocalStorage(process.env.REACT_APP_CURRENT_DEVICE_DETAILS || `sCDPC`) ||
  undefined;
export const removeCurrentDeviceDetails = () =>
  removeLocalStorage(process.env.REACT_APP_CURRENT_DEVICE_DETAILS || `sCDPC`);

export const setTempCurrentDeviceDetails = (value) =>
  setLocalStorage(
    process.env.REACT_APP_TEMP_CURRENT_DEVICE_DETAILS || `sTCDPC`,
    value,
    24
  );
export const getTempCurrentDeviceDetails = () =>
  getLocalStorage(
    process.env.REACT_APP_TEMP_CURRENT_DEVICE_DETAILS || `sTCDPC`
  );
export const removeTempCurrentDeviceDetails = () =>
  removeLocalStorage(
    process.env.REACT_APP_TEMP_CURRENT_DEVICE_DETAILS || `sTCDPC`
  );

// The last selected device is kept across logout (see cleanLocalStorage), so
// drop it when it is not one of the devices of the account now signed in.
export const removeForeignCurrentDevice = (devices) => {
  const isOwned = (device) =>
    (devices || []).some((item) => item.imei === device?.imei);
  if (!isOwned(getCurrentDeviceDetails())) removeCurrentDeviceDetails();
  if (!isOwned(getTempCurrentDeviceDetails())) removeTempCurrentDeviceDetails();
};

export const setCurrentDeviceStatusSettings = (value) =>
  setLocalStorage(
    process.env.REACT_APP_CURRENT_DEVICE_STATUS_SETTINGS || `sTCDSSPC`,
    value,
    24
  );
export const getCurrentDeviceStatusSettings = () =>
  getLocalStorage(
    process.env.REACT_APP_CURRENT_DEVICE_STATUS_SETTINGS || `sTCDSSPC`
  );
export const removeCurrentDeviceStatusSettings = () =>
  removeLocalStorage(
    process.env.REACT_APP_CURRENT_DEVICE_STATUS_SETTINGS || `sTCDSSPC`
  );

export const setUIDetails = (value) =>
  setLocalStorage(process.env.REACT_APP_UI_DETAILS || `sUIDPC`, value, 24);
export const getUIDetails = () =>
  getLocalStorage(process.env.REACT_APP_UI_DETAILS || `sUIDPC`) || undefined;
export const removeUIDetails = () =>
  removeLocalStorage(process.env.REACT_APP_UI_DETAILS || `sUIDPC`);

export const setUserExtraDetails = (value) =>
  setLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `sUDEPC`, value, 24);
export const getUserExtraDetails = () =>
  getLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `sUDEPC`) || undefined;
export const removeUserExtraDetails = () =>
  removeLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `sUDEPC`);

export const setAudioPlayRejacted = (value) =>
  setBoolLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `sUDAPC`, value, 24);
export const getAudioPlayRejacted = () =>
  getLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `sUDAPC`) || undefined;
export const removeAudioPlayRejacted = () =>
  removeLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `sUDAPC`);

export const setUserLanguage = (value) =>
  setLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `sULPC`, value, 24);
export const getUserLanguage = () =>
  getLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `sULPC`) || undefined;
export const removeUserLanguage = () =>
  removeLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `sULPC`);

export const setUserlasselectedtLanguage = (value) =>
  setLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `sltULPC`, value, 24);
export const getUserlasselectedLanguage = () =>
  getLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `sltULPC`) ||
  undefined;
export const removeUserlasselectedLanguage = () =>
  removeLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `sltULPC`);

export const setUserColorThemeMode = (value) =>
  setLocalStorage(
    process.env.REACT_APP_USER_COLOR_THEME_MODE || `sCUCTMPC`,
    value,
    24
  );
export const getUserColorThemeMode = () =>
  getLocalStorage(process.env.REACT_APP_USER_COLOR_THEME_MODE || `sCUCTMPC`) ||
  undefined;
export const removeUserColorThemeMode = () =>
  removeLocalStorage(process.env.REACT_APP_USER_COLOR_THEME_MODE || `sCUCTMPC`);

export const setQuickAccessView = (value) =>
  setLocalStorage(
    process.env.REACT_APP_QUICK_ACCESS_VIEW_DETAILS || `sQVPC`,
    value,
    24
  );
export const getQuickAccessView = () =>
  getLocalStorage(
    process.env.REACT_APP_QUICK_ACCESS_VIEW_DETAILS || `sQVPC`
  ) || undefined;
export const removeQuickAccessView = () =>
  removeLocalStorage(
    process.env.REACT_APP_QUICK_ACCESS_VIEW_DETAILS || `sQVPC`
  );

export const cleanLocalStorage = () => {
  removeAuthToken();
  removeAuthTokenType();
  removeUserDetails();
  // removeCurrentDeviceDetails(); // To make sure user atfer logout user get their last selected device after login
  // removeTempCurrentDeviceDetails(); // To make sure user atfer logout user get their last selected device after login
  removeCurrentDeviceStatusSettings();
  removeQuickAccessView();
};

export const clearWholeLocalStorage = () => {
  removeAuthToken();
  removeAuthTokenType();
  removeUserDetails();
  removeQuickAccessView();
}